import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    if (typeof window !== 'undefined' && window.console) {
      window.console.error('clarity:boundary', error)
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-md p-12 text-center">
          <h2 className="text-lg font-semibold">Une erreur est survenue</h2>
          <p className="mt-2 text-[13px] text-muted">{this.state.error.message || String(this.state.error)}</p>
          <button onClick={() => window.location.reload()} className="mt-6 rounded-lg bg-ink px-4 py-2 text-sm text-white">
            Recharger
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
